import { render } from "./NewCourse.vue?vue&type=template&id=2795ebe3&scoped=true"
import script from "./NewCourse.vue?vue&type=script&lang=js"
export * from "./NewCourse.vue?vue&type=script&lang=js"

import "./NewCourse.vue?vue&type=style&index=0&id=2795ebe3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2795ebe3"]])

export default __exports__